/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archon_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Legacy Excel Import" |
*
* @param {Archon_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archon_import_title = /** @type {((inputs?: Archon_Import_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archon_Import_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Import Excel historique")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar Excel histórico")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Importar Excel legado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa Excel storico")
	return /** @type {LocalizedString} */ ("Legacy Excel Import")
});